import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { ResponseStatus } from 'const';
import { updateModalWindowOptions } from 'containers/ModalManager/actions';
import * as Models from 'models';
import { updateReusableLayoutTags as updateReusableLayoutTagsAPI } from 'services/api';
import { handleSagaError } from 'services/handleError';
import { Notifications } from 'services/Notifications';
import { intlGet } from 'utils/intlGet';
import * as Action from '../models';

export function* updateReusableLayoutTags(action: Action.Action.UpdateReusableLayoutTags): SagaIterator {
  try {
    const { modalWindowId, documentId, tags } = action.payload;

    const response: Models.Response<Models.ProjectMetadataTags> = yield call(
      updateReusableLayoutTagsAPI,
      documentId,
      tags,
    );

    if (response.responseStatus === ResponseStatus.SUCCESS && response.data) {
      yield call([Notifications, Notifications.success], intlGet('Notification.Success', 'UpdateReusableLayoutTags'));
      yield put(updateModalWindowOptions(modalWindowId, { metadata: response.data }));
    } else {
      yield call(handleSagaError, response?.error, 'LayoutDetailsWindow.updateReusableLayoutTags', 'Update Reusable Layout Tags');
    }
  } catch (error) {
    yield call(handleSagaError, error, 'LayoutDetailsWindow.updateReusableLayoutTags', 'Update Reusable Layout Tags');
  }
}
